import * as React from 'react';

function IconStatusErrorMedium(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M12 3C10.22 3 8.47991 3.52784 6.99987 4.51677C5.51983 5.50571 4.36627 6.91131 3.68508 8.55585C3.0039 10.2004 2.82567 12.01 3.17293 13.7558C3.5202 15.5016 4.37737 17.1053 5.63604 18.364C6.89471 19.6226 8.49836 20.4798 10.2442 20.8271C11.99 21.1743 13.7996 20.9961 15.4442 20.3149C17.0887 19.6337 18.4943 18.4802 19.4832 17.0001C20.4722 15.5201 21 13.78 21 12C21 9.61305 20.0518 7.32387 18.364 5.63604C16.6761 3.94821 14.3869 3 12 3ZM12 19C10.6155 19 9.26215 18.5895 8.11101 17.8203C6.95987 17.0511 6.06266 15.9579 5.53284 14.6788C5.00303 13.3997 4.86441 11.9922 5.1345 10.6344C5.4046 9.2765 6.07129 8.02922 7.05025 7.05025C8.02922 6.07128 9.2765 5.4046 10.6344 5.1345C11.9922 4.86441 13.3997 5.00303 14.6788 5.53284C15.9579 6.06266 17.0511 6.95986 17.8203 8.11101C18.5895 9.26215 19 10.6155 19 12C19 13.8565 18.2625 15.637 16.9497 16.9497C15.637 18.2625 13.8565 19 12 19Z"
        fill="currentColor"
      />
      <path
        d="M14.29 8.29L12 10.59L9.71 8.29L8.29 9.71L10.59 12L8.29 14.29L9.71 15.71L12 13.41L14.29 15.71L15.71 14.29L13.41 12L15.71 9.71L14.29 8.29Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default IconStatusErrorMedium;
